<template>
	<div :class="progressBarClasses">
		<div :class="propertyInfoBarClasses">
			<div v-if="iconUrl" class="PropertyBarInfo__icon pull-left">
				<img :src="iconUrl">
			</div>
			<div v-if="!iconUrl" class="property-name pull-left">
				{{ actorProperty.property.names[locale] }}
			</div>
			<div class="PropertyBarInfo__value-text pull-right text-right">
				<animated-number
					:number="phaseCurrentValue"
					:animation-duration="maxAnimation"
					:value-units="valueUnits"
				></animated-number>
			</div>
		</div>
		<percent-from-center-bar
			:value="phaseCurrentValue"
			:min="min"
			:srv-middle="srvMiddle"
			:max="max"
			:increase-is-desirable="actorProperty.property.is_desirable"
			:show-diff-to-middle="showDiffToMiddle"
			:value-units="valueUnits"
			:key="`prop-${actorProperty.property_id}-effects`"
		></percent-from-center-bar>
	</div>
</template>

<script>
import PercentFromCenterBar from "../global_components/graphs_and_visualizations/percent_from_center_bar.vue";
// Other components
import { i18n } from "../utils";
import AnimatedNumber from "./animated_number.vue";

export default {
	// Naming - server = srv
	mixins: [i18n],
	props: {
		min: Number,
		srvMiddle: Number,
		max: Number,
		srvPropertyTypeKey: String,
		actorId: Number,
		phaseId: Number,
		iconUrl: String,
		hideInfoBar: Boolean,
		showLargeBar: Boolean,
		showDiffToMiddle: Boolean,
		smallTopMargin: Boolean,
		bottomMargin: Boolean,
	},
	data: function () {
		return {
			maxAnimation: 2,
			locale: I18n.locale,
		};
	},
	components: {
		"animated-number": AnimatedNumber,
		"percent-from-center-bar": PercentFromCenterBar,
	},
	computed: {
		actorProperty: function () {
			return VueStore.getters.actorPropertyOfTypeFor(
				this.actorId,
				this.srvPropertyTypeKey,
			);
		},
		progressBarClasses: function () {
			let classes = `HorizontalProgressBar ${this.actorProperty.property.color}`;
			if (this.showLargeBar) {
				classes += " HorizontalProgressBar--large";
			}
			if (this.smallTopMargin) {
				classes += " HorizontalProgressBar--small-top-margin";
			}
			if (this.bottomMargin) {
				classes += " HorizontalProgressBar--bottom-margin";
			}
			return classes;
		},
		propertyInfoBarClasses: function () {
			if (this.hideInfoBar) {
				return " hidden";
			}
			let classes = "PropertyBarInfo";
			if (this.phaseCurrentValue < 0) {
				classes += " PropertyBarInfo--negative-value";
			}
			if (this.iconUrl) {
				classes += " PropertyBarInfo--with-icon";
			}
			return classes;
		},
		valueUnits: function () {
			return this.actorProperty.property.value_units;
		},
		phaseCurrentValue: function () {
			return this.actorProperty.values[this.phaseId].current_value;
		},
	},
	methods: {},
};
</script>
